var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v(_vm._s(_vm.formTitleText))]),_c('p',[_vm._v(_vm._s(_vm.formSubtext))])])
}
var staticRenderFns = []

export { render, staticRenderFns }